import React, { FC } from 'react'
import { QuestionnaireItem } from '@medplum/fhirtypes'
import {
  DatePickerQuestion,
  InputQuestion,
  QuestionLayout,
  RadioQuestion
} from 'components/Assessments/components/QuestionComponents'
import { AnswersLayout } from 'components/Assessments/components/types'
import { useAssessmentContext } from 'contexts/AssessmentContext'
import SectionContainer from 'components/Assessments/components/SectionContainer'
import { PatientBackgroundFormField } from 'components/Assessments/PatAssessment/sections/PatientBackground/formField'
import { PatientBackgroundQuestionnaireItem } from 'components/Assessments/PatAssessment/sections/PatientBackground/questionnaire'

interface PatientVerificationSubsectionProps {
  subsection: QuestionnaireItem
  fieldMap: Record<string, QuestionnaireItem>
}

const PatientVerificationSubsection: FC<PatientVerificationSubsectionProps> = ({
  subsection,
  fieldMap
}) => {
  const { assessmentMustBeFinalized } = useAssessmentContext()

  // Find field items using the field map
  const legalNameField =
    fieldMap[PatientBackgroundQuestionnaireItem.PATIENT_VERIFICATION_LEGAL_NAME]
  const preferredNameField =
    fieldMap[PatientBackgroundQuestionnaireItem.PATIENT_VERIFICATION_PREFERRED_NAME]
  const addressField = fieldMap[PatientBackgroundQuestionnaireItem.PATIENT_VERIFICATION_ADDRESS]
  const dobField = fieldMap[PatientBackgroundQuestionnaireItem.PATIENT_VERIFICATION_DOB]
  const genderField = fieldMap[PatientBackgroundQuestionnaireItem.PATIENT_VERIFICATION_GENDER]
  const medicaidIdField =
    fieldMap[PatientBackgroundQuestionnaireItem.PATIENT_VERIFICATION_MEDICAID_ID]

  return (
    <SectionContainer subsection={subsection}>
      {legalNameField && (
        <InputQuestion
          field={legalNameField}
          formFieldName={PatientBackgroundFormField.LEGAL_NAME}
          layout={QuestionLayout.HORIZONTAL}
          disabled={true}
          required={assessmentMustBeFinalized}
        />
      )}

      {preferredNameField && (
        <InputQuestion
          field={preferredNameField}
          formFieldName={PatientBackgroundFormField.PREFERRED_NAME}
          layout={QuestionLayout.HORIZONTAL}
          disabled={true}
          required={false}
          placeholder="N/A"
        />
      )}

      {addressField && (
        <InputQuestion
          field={addressField}
          formFieldName={PatientBackgroundFormField.ADDRESS}
          layout={QuestionLayout.HORIZONTAL}
          disabled={true}
          required={assessmentMustBeFinalized}
        />
      )}

      {dobField && (
        <DatePickerQuestion
          field={dobField}
          formFieldName={PatientBackgroundFormField.DATE_OF_BIRTH}
          layout={QuestionLayout.HORIZONTAL}
          disabled={true}
          required={assessmentMustBeFinalized}
          format="MM/DD/YYYY"
        />
      )}

      {genderField && (
        <RadioQuestion
          field={genderField}
          formFieldName={PatientBackgroundFormField.GENDER}
          layout={QuestionLayout.HORIZONTAL}
          answersLayout={AnswersLayout.HORIZONTAL}
          disabled={true}
          required={assessmentMustBeFinalized}
        />
      )}

      {medicaidIdField && (
        <InputQuestion
          field={medicaidIdField}
          formFieldName={PatientBackgroundFormField.MEDICAID_ID}
          layout={QuestionLayout.HORIZONTAL}
          disabled={true}
          required={assessmentMustBeFinalized}
        />
      )}
    </SectionContainer>
  )
}

export default PatientVerificationSubsection
